/*
 * サブシステム名：
 * 機能名：配車表入力
 * 表示項目カスタマイズ(光陽テクノサービス)
 */
import D2PLMD1010 from '@/views/PLM/D2PLMD1010.js'
import date from '@/ddv2.library/date'
import indexeddb from '@/ddv2.library/indexeddb'
// import filter from '@/rahmen/utils/filters'

export default {
  extends: D2PLMD1010,
  name: 'HaishaMeisaiListEditCustomForKts',
  data: () => ({
    unkoYmdMultiFlg: true,
    conditionDetails: [
      { key: 'unkoYmdFromTo', name: '運行日', value: 'unkoYmdFromTo', delete: false },
      { key: 'haishahyoCd', name: '配車表', value: 'haishahyoNm', delete: true },
      // { key: 'haishaEigyoshoId', name: '配車営業所', value: 'haishaEigyoshoNm', delete: true },
      { key: 'sharyoId', name: '車両', value: 'sharyoNm', delete: true },
      { key: 'jininId1', name: '乗務員', value: 'jininNm1', delete: true },
      { key: 'tokuisakiId', name: '得意先', value: 'tokuisakiNm', delete: true }
    ],
    headerType: 'D2PLMD1011'
  }),
  computed: {
    currentEigyosho () {
      return indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate())
    },
    unchinKeisanKubunKurumadate () {
      return this.kubunList.find((elem) => {
        return elem.kbnShuruiCd === 'SFF055' && elem.code === '03'
      })
    }
  },
  methods: {
    setReadonlyCell: function (rowData, columnName) {
      // 元の処理を呼ぶ
      D2PLMD1010.methods.setReadonlyCell.call(this, rowData, columnName)

      if ([
        'warimashiJikanTanka',
        'warimashiKyoriTanka',
        'taikiJikanTanka',
        'tanka',
        'meisaiKihonUnchin',
        'meisaiJikanWarimashiKingaku',
        'meisaiKyoriWarimashiKingaku',
        'meisaiKeisuWarimashiKingaku',
        'meisaiNenryoWarimashiKingaku',
        'meisaiHiwayPrice',
        'meisaiNenryoSurcharge',
        'meisaiTsumikomiKingaku',
        'meisaiTorioroshiKingaku',
        'meisaiTaikiJikanKingaku',
        'meisaiFutaiGyomuKingaku',
        'meisaiFutaiGyomuKingaku1',
        'meisaiFutaiGyomuKingaku2',
        'meisaiFutaiGyomuKingaku3',
        'meisaiFutaiGyomuKingaku4',
        'meisaiFutaiGyomuKingaku5',
        'meisaiFutaiGyomuKingaku6',
        'meisaiFutaiGyomuKingaku7',
        'meisaiFutaiGyomuKingaku8',
        'meisaiFutaiGyomuKingaku9',
        'meisaiFutaiGyomuKingaku10',
        'meisaiUserKingakuKazei1',
        'meisaiUserKingakuKazei2',
        'meisaiUserKingakuKazei3',
        'meisaiUserKingakuKazei4',
        'meisaiUserKingakuKazei5',
        'meisaiUserKingakuKazei6',
        'meisaiUserKingakuKazei7',
        'meisaiUserKingakuKazei8',
        'meisaiUserKingakuKazei9',
        // 'meisaiUserKingakuKazei10',
        'meisaiUserKingakuHikazei1',
        'meisaiUserKingakuHikazei2',
        'meisaiUserKingakuHikazei3',
        'meisaiUserKingakuHikazei4',
        'meisaiUserKingakuHikazei5',
        'meisaiUserKingakuHikazei6',
        'meisaiUserKingakuHikazei7',
        'meisaiUserKingakuHikazei8',
        'meisaiUserKingakuHikazei9',
        'meisaiUserKingakuHikazei10',
        'meisaiUserKingakuUchizei1',
        'meisaiUserKingakuUchizei2',
        'meisaiUserKingakuUchizei3',
        'meisaiUserKingakuUchizei4',
        'meisaiUserKingakuUchizei5',
        'meisaiUserKingakuUchizei6',
        'meisaiUserKingakuUchizei7',
        'meisaiUserKingakuUchizei8',
        'meisaiUserKingakuUchizei9',
        'meisaiUserKingakuUchizei10',
        'meisaiHanyoKingaku1',
        'meisaiHanyoKingaku2',
        'meisaiHanyoKingaku3',
        'meisaiHanyoKingaku4',
        'meisaiHanyoKingaku5',
        'meisaiHanyoKingakuZeiKbn1',
        'meisaiHanyoKingakuZeiKbn2',
        'meisaiHanyoKingakuZeiKbn3',
        'meisaiHanyoKingakuZeiKbn4',
        'meisaiHanyoKingakuZeiKbn5',
        'hinmokuKihonUnchin',
        'hinmokuJikanWarimashiKingaku',
        'hinmokuKyoriWarimashiKingaku',
        'hinmokuKeisuWarimashiKingaku',
        'hinmokuNenryoWarimashiKingaku',
        'hinmokuHiwayPrice',
        'hinmokuNenryoSurcharge',
        'hinmokuTsumikomiKingaku',
        'hinmokuTorioroshiKingaku',
        'hinmokuTaikiJikanKingaku',
        'hinmokuFutaiGyomuKingaku',
        'hinmokuFutaiGyomuKingaku1',
        'hinmokuFutaiGyomuKingaku2',
        'hinmokuFutaiGyomuKingaku3',
        'hinmokuFutaiGyomuKingaku4',
        'hinmokuFutaiGyomuKingaku5',
        'hinmokuFutaiGyomuKingaku6',
        'hinmokuFutaiGyomuKingaku7',
        'hinmokuFutaiGyomuKingaku8',
        'hinmokuFutaiGyomuKingaku9',
        'hinmokuFutaiGyomuKingaku10',
        'hinmokuUserKingakuKazei1',
        'hinmokuUserKingakuKazei2',
        'hinmokuUserKingakuKazei3',
        'hinmokuUserKingakuKazei4',
        'hinmokuUserKingakuKazei5',
        'hinmokuUserKingakuKazei6',
        'hinmokuUserKingakuKazei7',
        'hinmokuUserKingakuKazei8',
        'hinmokuUserKingakuKazei9',
        'hinmokuUserKingakuKazei10',
        'hinmokuUserKingakuHikazei1',
        'hinmokuUserKingakuHikazei2',
        'hinmokuUserKingakuHikazei3',
        'hinmokuUserKingakuHikazei4',
        'hinmokuUserKingakuHikazei5',
        'hinmokuUserKingakuHikazei6',
        'hinmokuUserKingakuHikazei7',
        'hinmokuUserKingakuHikazei8',
        'hinmokuUserKingakuHikazei9',
        'hinmokuUserKingakuHikazei10',
        'hinmokuUserKingakuUchizei1',
        'hinmokuUserKingakuUchizei2',
        'hinmokuUserKingakuUchizei3',
        'hinmokuUserKingakuUchizei4',
        'hinmokuUserKingakuUchizei5',
        'hinmokuUserKingakuUchizei6',
        'hinmokuUserKingakuUchizei7',
        'hinmokuUserKingakuUchizei8',
        'hinmokuUserKingakuUchizei9',
        'hinmokuUserKingakuUchizei10',
        'hinmokuHanyoKingaku1',
        'hinmokuHanyoKingaku2',
        'hinmokuHanyoKingaku3',
        'hinmokuHanyoKingaku4',
        'hinmokuHanyoKingaku5',
        'hinmokuHanyoKingakuZeiKbn1',
        'hinmokuHanyoKingakuZeiKbn2',
        'hinmokuHanyoKingakuZeiKbn3',
        'hinmokuHanyoKingakuZeiKbn4',
        'hinmokuHanyoKingakuZeiKbn5'
      ].includes(columnName)) {
        const value = Number(rowData.meisaiUserKingakuKazei10)
        if (!Number.isNaN(value) && value !== 0) {
          return true // ← そのセルを読み取り専用に
        }
      }
    },
    setNewRow: function () {
      const eigyoshoId = this.currentEigyosho?.id
      const userEigyoshoNm = this.currentEigyosho?.eigyoshoNm
      const unchinKeisanKubunKurumadateNm = this.unchinKeisanKubunKurumadate?.codeNm
      this.newRecordId -= 1
      const baseYmd = this.conditions.sagyoYoteiYmd ?? this.conditions.sagyoYoteiYmdFrom ?? date.getCurrentDate()
      return {
        rowNo: this.rows.length + 1,

        // Key♯1
        id: this.newRecordId,
        trSagyoKeikakuMeisaiId: this.newRecordId,
        trSagyoKeikakuSharyoId: this.newRecordId,
        trSagyoKeikakuJininId1: this.newRecordId,
        trSagyoKeikakuJininId2: this.newRecordId,
        // Key#2
        trSagyoMeisaiId: this.newRecordId,
        trSagyoHinmokuId: this.newRecordId,
        trSagyoKingakuId: this.newRecordId,
        trJuchuKihonId: this.newRecordId,
        trJuchuMeisaiId: this.newRecordId,
        trJuchuHinmokuId: this.newRecordId,
        trJuchuKingakuId: this.newRecordId,
        // Key#3 ※2025.08.28 今後のために初期セットしておく
        trUnkoJissekiId: this.newRecordId,
        trSagyoJissekiId: this.newRecordId,
        trKintaiJissekiId1: this.newRecordId,
        trKintaiJissekiId2: this.newRecordId,
        trSharyoKeihiId: this.newRecordId,

        // 計画基本
        sagyoYoteiYmd: null,
        haishaShashuSbt: null,
        eigyoshoId: eigyoshoId,
        // sagyoYoteiStartYmd: null,  ※API側で設定するためここではなにもしない
        // sagyoYoteiEndYmd: null,    ※同上
        // 計画車両
        jidoshaHyojiNm: null,
        unkoSeqNo: null,
        // 計画人員（主）
        jininNm1: null,
        // 計画人員（副）
        jininNm2: null,

        // 受注
        sagyoKaiji: null,
        sagyoKaijiJunban: null,
        sagyoOrder: null,
        juchuYmd: baseYmd,
        chmonNo: null,
        juchuMeisaiNo: 1,
        juchuEigyoshoId: eigyoshoId,
        juchuEigyoshoNm: userEigyoshoNm,
        tokuisakiNm: null,
        niukeninNm: null,
        hatsuchiNm: null,
        hatsuchiYmd: null,
        hatsuchiHms: null,
        hatsuchiHmsBiko: null,
        hatsuchiBiko: null,
        keiyuchiId1: null,
        keiyuchiId1Biko: null,
        keiyuchiId2: null,
        keiyuchiId2Biko: null,
        keiyuchiId3: null,
        keiyuchiId3Biko: null,
        keiyuchiId4: null,
        keiyuchiId4Biko: null,
        keiyuchiId5: null,
        keiyuchiId5Biko: null,
        chakuchiNm: null,
        chakuchiYmd: null,
        chakuchiHms: null,
        chakuchiHmsBiko: null,
        chakuchiBiko: null,
        haishaBiko: null,
        renrakuBiko: null,
        denpyoBiko1: null,
        denpyoBiko2: null,
        denpyoBiko3: null,
        denpyoBiko4: null,
        denpyoBiko5: null,
        denpyoBiko6: null,
        denpyoBiko7: null,
        denpyoBiko8: null,
        denpyoBiko9: null,
        denpyoBiko10: null,
        hinshuSbtNm: null,
        hinmeiNm: null,
        juchuSuryo: null,
        unitKbnNm: null,
        juchuJuryo: null,
        tanka: null,
        seikyuYoteiYmd: null,
        // 固定
        unchinKeisanKbnNm: unchinKeisanKubunKurumadateNm,
        seikyuShashuSbtNm: null,
        kihonUnchin: null,
        hiwayPrice: null,
        unchinHokaKingaku: null,
        unchinHokaHikazei: null,
        jikanWarimashiKingaku: null,
        kyoriWarimashiKingaku: null,
        warimashiSonotaKingsku: null,
        seikyuKingakuGokei: null,
        seikyuBiko: null,
        shiharaiYoteiYmd: null,
        yoshaKihonUnchin: null,
        yoshaHiwayPrice: null,
        yoshaUnchinHokaKingaku: null,
        yoshaUnchinHokaHikazei: null,
        shiharaiKingakuGokei: null
      }
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        sagyoYoteiYmdFrom: date.getCurrentDate(),
        sagyoYoteiYmdTo: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        // haishaEigyoshoId: this.eigyoshoReadOnly ? indexeddb.getRecordByCd(this.currentKaishaCode, this.filteredEigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).id : null,
        haishahyoCd: null,
        eigyoshoId: null,
        tokuisakiId: null,
        layoutType: 'D2PLMD1011'
      }
      this.conditions = {
        ...initConditions,
        // 表示用
        unkoYmdFromTo: initConditions.sagyoYoteiYmdFrom + '～' + initConditions.sagyoYoteiYmdTo,
        haishahyoNm: null,
        haishaEigyoshoNm: null,
        sharyoNm: null,
        jomuinNm: null
      }
      this.isAfterSearch = false
      this.haishaChohyoSbt = '0'
      this.nohinshoChohyoSbt = '99'
      this.searchText = ''
      this.rows = []
      this.page = 1
    },
    /**
     * スプレッドシート変更後イベント
     * @param {*} rowData
     * @param {*} cell
     * @param {*} x
     * @param {*} y
     * @param {*} newValue
     * @param {*} oldValue
     */
    changeAfter (rowData, cell, x, y, newValue, oldValue) {
      // 元の処理を呼ぶ
      D2PLMD1010.methods.changeAfter.call(this, rowData, cell, x, y, newValue, oldValue)

      // 徴収金額
      if (Number(x) === this.computedColNumList.meisaiUserKingakuKazei10) {
        const value = Number(this.rows[y].meisaiUserKingakuKazei10) > 0 ? Number(this.rows[y].meisaiUserKingakuKazei10) * -1 : Number(this.rows[y].meisaiUserKingakuKazei10)
        const ref = this.$refs.ddSpreadSheet

        if (value !== this.rows[y].meisaiUserKingakuKazei10) {
          // マイナス表記
          ref.jspreadsheetObj.setValue(cell, value, true)
        }
        // 請求金額は読み取り専用＆未入力化
        const isReadonly = value < 0
        const targetXList = [
          this.computedColNumList.tanka,
          this.computedColNumList.meisaiUserKingakuKazei1,
          this.computedColNumList.meisaiHiwayPrice,
          this.computedColNumList.meisaiTaikiJikanKingaku,
          this.computedColNumList.meisaiFutaiGyomuKingaku1,
          this.computedColNumList.meisaiFutaiGyomuKingaku2,
          this.computedColNumList.meisaiTsumikomiKingaku,
          this.computedColNumList.meisaiUserKingakuKazei5,
          this.computedColNumList.meisaiUserKingakuKazei6,
          this.computedColNumList.meisaiFutaiGyomuKingaku3,
          this.computedColNumList.meisaiUserKingakuKazei4,
          this.computedColNumList.meisaiUserKingakuKazei7
        ]
        targetXList.forEach(targetX => {
          // 読み取り専用化 かつ変更時の黄色背景色を無効化
          const targetCellNm = ref.getCellNameFromCoords(targetX, y)
          const targetCell = ref.getCellFromCellName(targetCellNm)
          if (targetCell) { targetCell.classList.remove('changeCell') }
          ref.setCellReadonly(targetX, y, isReadonly)
          // 未入力化
          if (isReadonly) {
            ref.jspreadsheetObj.setValueFromCoords(targetX, y, '', true)
          }
        })

        // 請求金額自動計算
        this.calcedSeikyuKingaku(y, 0)
      }
      // 単価 ※deleteキーで消去すると請求運賃に金額が残ってしまうためその対応
      if (Number(x) === this.computedColNumList.tanka) {
        if (!this.rows[y].tanka) {
          // 請求金額自動計算
          this.calcedSeikyuKingaku(y, 0)
        }
      }
    },
    calcedSeikyuKingaku: function (y, value) {
      if (this.computedColNumList.hinmokuKihonUnchin || this.computedColNumList.meisaiKihonUnchin) {
        const hinmoku = this.computedColNumList.hinmokuKihonUnchin ? 'hinmoku' : ''
        var unchinCell
        if (![undefined, null, ''].includes(hinmoku)) {
          unchinCell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hinmokuKihonUnchin, y)
        } else {
          unchinCell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.meisaiKihonUnchin, y)
        }

        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(unchinCell, Math.round(value), true)
      }
    }
  }
}
